import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loader2, Plus } from "lucide-react";
import { useContentLibrary } from "./content/useContentLibrary";
import { ContentCard } from "./content/ContentCard";
import { ContentFilters, ContentEmptyState } from "./content/ContentFilters";

const ContentView = () => {
  const c = useContentLibrary();

  if (c.loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="content-view-loading">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin text-ism-teal mx-auto mb-4" />
          <p className="text-gray-400">Loading content library...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6" data-testid="content-view">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-medium text-ism-teal">Content Library</h1>
          <p className="text-gray-400 text-sm mt-1">Sales materials and templates</p>
        </div>
        <Button onClick={c.create} className="bg-ism-teal hover:bg-ism-teal-light text-white" data-testid="create-content-btn">
          <Plus className="h-4 w-4 mr-2" />
          Create Content
        </Button>
      </div>
      <ContentFilters query={c.query} setQuery={c.setQuery} category={c.category} setCategory={c.setCategory} />
      {c.filtered.length === 0 ? (
        <ContentEmptyState onCreate={c.create} />
      ) : (
        <ScrollArea className="h-[calc(100vh-300px)]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pr-4">
            {c.filtered.map((item, index) => <ContentCard key={item.id || index} item={item} index={index} onPersonalize={c.personalize} />)}
          </div>
        </ScrollArea>
      )}
    </div>
  );
};

export default ContentView;
